"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
class AdminsOnlyHeader extends react_1.default.Component {
    render() {
        const { isAppAdmin, isWorkspaceAdmin, topBorder } = this.props;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            topBorder !== false && react_1.default.createElement("hr", { className: "mt-5 mb-3" }),
            react_1.default.createElement("p", { className: "text-danger text-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faLock }),
                ' ',
                isAppAdmin && isWorkspaceAdmin
                    ? 'Admins only'
                    : isAppAdmin
                        ? 'App admins only'
                        : isWorkspaceAdmin
                            ? 'Workspace admins only'
                            : '',
                ' ')));
    }
}
exports.AdminsOnlyHeader = AdminsOnlyHeader;
//# sourceMappingURL=AdminsOnlyHeader.js.map